import { render, staticRenderFns } from "./PageHead.vue?vue&type=template&id=99ad0dcc&scoped=true&"
import script from "./PageHead.vue?vue&type=script&lang=js&"
export * from "./PageHead.vue?vue&type=script&lang=js&"
import style0 from "./PageHead.vue?vue&type=style&index=0&id=99ad0dcc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ad0dcc",
  null
  
)

export default component.exports